import {
  IBrandUser,
  IcreateUpdateBrandUserProps,
  IInitialBrandUsersState,
} from 'interfaces/brandUsers.interface';
import * as BrandUsersTypes from './brandUsers.types';
import { InotificationsTypesItem } from 'interfaces/notifications.interface';

export type TbrandUsersDispatchReducer =
  | {
      type: typeof BrandUsersTypes.GET_BRAND_USERS;
      payload: Array<IBrandUser>;
    }
  | {
      type: typeof BrandUsersTypes.CREATE_BRAND_USER;
      payload: IBrandUser;
    }
  | {
      type: typeof BrandUsersTypes.UPDATE_BRAND_USER;
      payload: {
        key: string;
        user: IcreateUpdateBrandUserProps;
        notifications: Array<InotificationsTypesItem>;
      };
    }
  | {
      type: typeof BrandUsersTypes.SELECT_BRAND_USER;
      payload: IBrandUser | null;
    }
  | {
      type: typeof BrandUsersTypes.DELETE_BRAND_USER;
      payload: string;
    }
  | {
      type: typeof BrandUsersTypes.SET_IS_LOADING_ACTION;
      payload: boolean;
    }
  | {
      type: typeof BrandUsersTypes.SET_IS_LOADING_USERS;
      payload: boolean;
    };

export default function brandUsersReducer(
  state: IInitialBrandUsersState,
  action: TbrandUsersDispatchReducer
) {
  const { type, payload } = action;

  switch (type) {
    case BrandUsersTypes.GET_BRAND_USERS:
      const getBrandUsers: IInitialBrandUsersState = {
        ...state,
        brandUsers: payload,
      };
      return getBrandUsers;

    case BrandUsersTypes.SELECT_BRAND_USER:
      const selectBrandUser: IInitialBrandUsersState = {
        ...state,
        brandUsersSelected: payload,
      };
      return selectBrandUser;

    case BrandUsersTypes.CREATE_BRAND_USER:
      const createBrandUser: IInitialBrandUsersState = {
        ...state,
        brandUsers: [...state.brandUsers, payload],
      };
      return createBrandUser;

    case BrandUsersTypes.UPDATE_BRAND_USER:
      const updateBrandUser: IInitialBrandUsersState = {
        ...state,
        brandUsers: state.brandUsers.map((user) => {
          const updatedUser: IBrandUser = {
            ...user,
            ...payload.user,
            user_point_of_sales: payload.user.pointsOfSale,
            user_notifications: payload.notifications,
          };

          return user.key === payload.key ? updatedUser : user;
        }),
      };
      return updateBrandUser;

    case BrandUsersTypes.DELETE_BRAND_USER:
      const deleteBrandUser: IInitialBrandUsersState = {
        ...state,
        brandUsers: state.brandUsers.filter((user) => user.id !== payload),
      };
      return deleteBrandUser;

    case BrandUsersTypes.SET_IS_LOADING_ACTION:
      const setIsLoadingAction: IInitialBrandUsersState = {
        ...state,
        isLoadingAction: payload,
      };
      return setIsLoadingAction;

    case BrandUsersTypes.SET_IS_LOADING_USERS:
      const setIsLoadingUsers: IInitialBrandUsersState = {
        ...state,
        isLoadingUsers: payload,
      };
      return setIsLoadingUsers;

    default:
      return state;
  }
}
